import { useEffect, useMemo, useState } from 'react';
import { Platforms } from '../enums';

export function useInviteModal(referralCode: string, username: string) {
   const [hasCopiedLink, setHasCopiedLink] = useState(false);
   const [hasCopiedCode, setHasCopiedCode] = useState(false);

   const referralLink = useMemo(() => {
      return `tinyurl.com/yurun6by?referral=${referralCode}&referredby=${username}`;
      // return `${window.location.origin}/signup?referral=${referralCode}`;
   }, [referralCode]);

   useEffect(() => {
      if (hasCopiedLink) {
         const timoutId = setTimeout(() => {
            setHasCopiedLink(false);
         }, 2000);

         return () => {
            clearTimeout(timoutId);
         };
      }
   }, [hasCopiedLink]);

   useEffect(() => {
      if (hasCopiedCode) {
         const timoutId = setTimeout(() => {
            setHasCopiedCode(false);
         }, 2000);

         return () => {
            clearTimeout(timoutId);
         };
      }
   }, [hasCopiedCode]);

   const copyLink = () => {
      setHasCopiedLink(true);
      navigator.clipboard.writeText(referralLink);
   };

   const copyCode = () => {
      setHasCopiedCode(true);
      navigator.clipboard.writeText(referralCode);
   };

   const sendVia = (platform: Platforms) => {
      switch (platform) {
         case Platforms.TWITTER:
            const tweet = `Join me on GolfN and get rewarded!%0A%0AUse my referral link to sign up:%0A${referralLink}%0A%0A@GolfNApp`;
            const twitterUrl = `https://x.com/intent/post?text=${tweet}`;
            window.open(twitterUrl, '_blank');
            break;
         case Platforms.TELEGRAM:
            window.open(`https://t.me/share/url?url=${referralLink}`, '_blank');
            break;
         case Platforms.WHATSAPP:
            const text = `Join me on GolfN and get rewarded!%0A%0AUse my referral link to sign up:%0A${referralLink}`;
            window.open(`https://api.whatsapp.com/send?text=${text}`, '_blank');
            break;
         case Platforms.MESSAGE:
            window.open(`sms:?&body=${referralLink}`, '_blank');
            break;
         case Platforms.MORE:
            if (navigator.share) {
               navigator
                  .share({
                     title: 'GolfN - Join me and get rewarded!',
                     text: 'GolfN, The app that rewards you to play golf!',
                     url: referralLink,
                  })
                  .catch((error) => {
                     console.error('Error sharing:', error);
                  });
            }
            break;
         default:
            console.error('Unknown platform:', platform);
            break;
      }
   };

   return {
      hasCopiedLink,
      hasCopiedCode,
      referralLink,
      copyLink,
      copyCode,
      sendVia,
   };
}
